



























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import TextField from "@/components/inputs/TextField.vue";
import Number from "@/components/inputs/Number.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {visibilityOptions, VisibilityEnum} from "@/entity/SiteEntity";

interface SliderEntity {
    slider_id: number;
    image_url: string;
    thumb_url: string;
    mobile_image_url: string | null;
    title: string;
    description: string;
    url: string;
    button_text: string | null;
    button_url: string | null;
    status: number | string;
    starts_at: string | null;
    ends_at: string | null;
    text_align: string | null;
    text_color: string | null;
    overlay: number | string;
    site_id: number | null;
    no: number;
}

class requestPaylaod {
    slider_id: number | null = null;
    file: File | null = null;
    mobile_file: File | null = null;
    title: string = "";
    description: string = "";
    url: string = "";
    button_text: string = "";
    button_url: string = "";
    thumb_url: string = "";
    mobile_image_url: string = "";
    status: number = 1;
    starts_at: string = "";
    ends_at: string = "";
    text_align: string = "left";
    text_color: string = "";
    overlay: number = 30;
    visibility: string = VisibilityEnum.Site;
    no: number | null = null;
}

@Component({
    components: {
        DeleteButton,
        EForm,
        Id,
        TextField,
        Number,
        ImageUpload
    }
})
export default class Slider extends Vue {
    baseAction: string = ActionsEnum.Slider;
    action: string = this.baseAction;
    dialog: boolean = false;
    items: Array<SliderEntity> | null = null;
    title: string = "";
    uploadRequired = true;
    data: requestPaylaod = new requestPaylaod();

    statusOptions = [
        {text: "Yayında", value: 1},
        {text: "Taslak", value: 0},
    ];
    alignOptions = [
        {text: "Sola hizalı", value: "left"},
        {text: "Ortalı", value: "center"},
        {text: "Sağa hizalı", value: "right"},
    ];
    visibilityOptions = visibilityOptions;

    onMobileFile(event: any) {
        const files = event.target.files;
        this.data.mobile_file = files && files.length > 0 ? files[0] : null;
    }

    edit(item: SliderEntity) {
        this.data = new requestPaylaod();
        this.data.file = null;
        this.data.description = item.description;
        this.data.no = item.no;
        this.data.title = item.title;
        this.data.url = item.url;
        this.data.slider_id = item.slider_id;
        this.data.thumb_url = item.thumb_url;
        this.data.mobile_image_url = item.mobile_image_url || "";
        this.data.button_text = item.button_text || "";
        this.data.button_url = item.button_url || "";
        this.data.status = window.Number(item.status);
        this.data.starts_at = item.starts_at || "";
        this.data.ends_at = item.ends_at || "";
        this.data.text_align = item.text_align || "left";
        this.data.text_color = item.text_color || "";
        this.data.overlay = item.overlay === null ? 30 : window.Number(item.overlay);
        this.data.visibility = item.site_id === null ? VisibilityEnum.All : VisibilityEnum.Site;
        this.action = this.baseAction + "/" + item.slider_id;
        this.title = "Düzenle";
        this.uploadRequired = false;
        this.dialog = true;
    }

    add() {
        this.title = "Ekle";
        this.data = new requestPaylaod();
        this.action = this.baseAction;
        this.uploadRequired = true;
        this.dialog = true;
    }

    async getSliders() {
        this.dialog = false;
        let slider = await this.$http.get(this.baseAction);
        this.items = slider.data;
    }

    created() {
        this.getSliders();
    }
}
